export enum DecimalSymbol {
    COMMA = ',',
    POINT = '.'
}
